import { Injectable } from '@angular/core';

import type {
  ProtectedControlDirective,
  ProtectedControlMeta,
} from './protected-control.directive';
import type { ProtectedControlsContext } from './protected-controls.context';

@Injectable()
export class ProtectedControlsService {
  private directives = new Set<ProtectedControlDirective>();
  private discarded: boolean = false;
  private _reports: ProtectedControlMeta[] = [];
  private contextPayloads = new Map<ProtectedControlsContext, any>();

  public setContextPayload(protectedControlsContext: ProtectedControlsContext, payload: any): void {
    this.contextPayloads.set(protectedControlsContext, payload);
  }

  public clearContextPayload(protectedControlsContext: ProtectedControlsContext): void {
    this.contextPayloads.delete(protectedControlsContext);
  }

  public register(control: ProtectedControlDirective): void {
    this.discarded = false;
    this.directives.add(control);
  }

  public unregister(control: ProtectedControlDirective): void {
    this.directives.delete(control);

    if (this.directives.size === 0) {
      this.discarded = true;
    }
  }

  public get locked(): boolean {
    if (this.discarded) {
      return false;
    }

    this._reports = Array.from(this.directives).reduce(
      (agg, directive) => (directive.locked ? [...agg, directive.meta] : agg),
      [],
    );

    return this._reports.length > 0;
  }

  public get reports(): ProtectedControlMeta[] {
    return this._reports;
  }

  public discard(): void {
    this.contextPayloads.clear();
    this._reports = [];
    this.discarded = true;
  }
}
